import { deleteChallengeGroup } from '@actions/challengeGroups/deleteChallengeGroup';
import { RootState } from '@reducers/index';
import {
    getChallengeGroupsDeleteSuccess,
    getChallengeGroupsIsDeleting,
    getChallengeGroup,
    getChallengeGroupsDeleteError,
} from '@selectors/challengeGroups';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

const useDeleteChallengeGroup = (id: number) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const challengeGroup = useSelector((state: RootState) => getChallengeGroup(state, id));

    const handleSubmit = useCallback(() => dispatch(deleteChallengeGroup(id)), [dispatch, id]);

    const isDeleting = useSelector(getChallengeGroupsIsDeleting);
    const deleteError = useSelector(getChallengeGroupsDeleteError);
    const deleteSuccess = useSelector(getChallengeGroupsDeleteSuccess);
    const { deleteSuccess: prevDeleteSuccess } = usePrevious({ deleteSuccess });
    useEffect(() => {
        if (!prevDeleteSuccess && deleteSuccess) {
            history.replace('/challenge-groups');
        }
    }, [deleteSuccess, prevDeleteSuccess, history]);

    return { challengeGroup, handleSubmit, isDeleting, deleteError };
};

export default useDeleteChallengeGroup;
